import React from 'react';
import { CardContainer, HeaderContainer, LatestText, IconWrapper, LatestNoiftDropdown, LatestNoiftItem } from './LatestNoift.styles';

const LatestNoift = ({ activities }) => {
    return (
        <CardContainer>
            <HeaderContainer>
                <IconWrapper />
                <LatestText>Latest activities</LatestText>
            </HeaderContainer>
            <LatestNoiftDropdown>
                {activities.length > 0 ? (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '200px', // 可依卡片高度微調
                        flexDirection: 'column',
                        textAlign: 'center',
                    }}>
                        <LatestNoiftItem style={{ justifyContent: 'center', gap: '12px', fontSize: '16px', color: '#697077' }}>
                            <span>{activities[0].description}</span>
                            <span>{activities[0].date}</span>
                        </LatestNoiftItem>

                        {/* 原本的樣式保留註解 */}
                        {/* {activities.map((activity, index) => (
            <LatestNoiftItem key={index}>
                <span>{activity.description}</span>
                <span>{activity.date}</span>
            </LatestNoiftItem>
        ))} */}
                    </div>
                ) : (
                    <p style={{ textAlign: 'center', padding: '40px 0' }}>No recent activities</p>
                )}
            </LatestNoiftDropdown>
        </CardContainer>
    );
};

export default LatestNoift;
